import React, { useState } from 'react'
import getActivityChartOptions from '../../../utils/charts/activityChart'
import ChartModule from './ChartModule'
import TabPanel from '../../layout/TabPanel'
import ActivityTable from '../Tables/ActivityTable'
import { Box, Card, CardContent, Tab, Tabs, Typography } from '@mui/material'

function a11yProps (index) {
  return {
    id: `activity-metric__tab-${index}`,
    'aria-controls': `activity-metric__tab-${index}`
  }
}

export default function ActivityChart (props) {
  const [selectedActivityTab, setSelectedActivityTab] = useState(0)

  const renderChartPanel = () => {
    return (
      <Card className='chart-card'>
        <CardContent sx={{ pt: 0 }}>
          <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'end', m: 0 }}>
            <Typography variant='h6' color='#7f7f7f'> Activity </Typography>
            <Tabs
              sx={{ borderBottom: 1, borderColor: 'divider' }}
              value={selectedActivityTab}
              onChange={(_e, val) => setSelectedActivityTab(val)}
              aria-label='Profile tabs'
            >
              <Tab data-testid='activity__charts-tab' label='Graph' {...a11yProps(0)} />
              <Tab data-testid='activity__table-tab' label='Table' {...a11yProps(1)} />
            </Tabs>
          </Box>
          <TabPanel value={selectedActivityTab} index={0} noPadding>
            <ChartModule
              hideHeader
              hideBorder
              showChartActions
              dashboardViewStore={props.dashboardViewStore}
              memberObj={props.memberObj}
              metricType='activity'
              getChartOptions={getActivityChartOptions}
              showMemberAlerts
              handleAlertClick={props.handleAlertClick} // eslint-disable-line react/jsx-handler-names
            />
          </TabPanel>
          <TabPanel value={selectedActivityTab} index={1} noPadding>
            <ActivityTable
              hideHeader
              hideBorder
              dashboardViewStore={props.dashboardViewStore}
              memberObj={props.memberObj}
            />
          </TabPanel>
        </CardContent>
      </Card>

    )
  }

  return renderChartPanel()
}
